export default __webpack_public_path__ + "static/media/Slide40.430e52e0.PNG";